import React from 'react';

import { PrimaryButton } from '@components/Button/variants';
import LazyImgixImage from '@components/LazyImgixImage';
import SectionBreakTitle, { SectionColor } from '@components/SectionBreakTitle';
import Spinner from '@components/Spinner';
import {
  useCurrentUser,
  useGiftSubscriptionSettings,
  useGroupSubscriptionsRecipients,
} from '@hooks';
import { gift_landing_path } from '@routes';
import { IMGIX_URL } from '@src/env';
import { GROUP_SUBSCRIPTION_GIFT } from '@utils/constants';

import SubscriptionOverview from '../GroupSubscription/SubscriptionOverview';
import SettingHeaderSeperator from '../SettingHeaderSeperator';
import GiftForm from './GiftForm';
import styles from './styles.module.scss';

export const GIFT_SUBSCRIPTION_HEADER = `${IMGIX_URL}/global/gift/gift_subscription_header.gif`;

const Gift = () => {
  const { data: recipients, isLoading } = useGroupSubscriptionsRecipients(GROUP_SUBSCRIPTION_GIFT);
  const { currentUser, isLoadingCurrentUser } = useCurrentUser();
  const { giftSubscriptionSetting, isGiftSettingsLoading } = useGiftSubscriptionSettings();
  const isSubscriber = currentUser?.is_active_stripe_subscriber;

  return (
    <>
      {isLoading || isLoadingCurrentUser || isGiftSettingsLoading ? (
        <Spinner />
      ) : (
        <>
          <SectionBreakTitle
            className="mb-32"
            titleClassName="text-primary-magenta"
            color={SectionColor.Magenta}
            title="Gift subscriptions"
          />
          <div className={styles.giftSubHeader} id="GiftSubHeader">
            {isSubscriber ? (
              <>
                You can give others access to The Information. Share as a gift or with your team—add
                additional subscribers for ${giftSubscriptionSetting?.offer?.initialPrice} a year
                per person.
              </>
            ) : (
              <>
                <p className="font-suisse-intl text-description-lg">
                  More than a gift, an advantage. Share the exclusive reporting that shapes how
                  ambitious people think, work and win. Give{' '}
                  <span className="font-bold">The Information</span> to your friends, team members
                  or colleagues. <span className="font-bold">Get 25% off for the first year.</span>
                </p>
                <LazyImgixImage
                  alt="The Information Header"
                  className="w-full"
                  src={GIFT_SUBSCRIPTION_HEADER}
                  sizes=""
                  wrapperClassName="w-full"
                />
                <PrimaryButton as="link" href={gift_landing_path()} fullWidth className="mt-24">
                  Give a Subscription
                </PrimaryButton>
              </>
            )}
          </div>
          {isSubscriber && (
            <>
              <div className="mb-48">
                <GiftForm />
              </div>

              <SettingHeaderSeperator sectionName="Subscriptions" />
              <div className={styles.giftSubHeader} id="GiftSubHeader">
                You are currently supporting the following subscriptions for others to The
                Information
              </div>
              <SubscriptionOverview
                recipients={recipients}
                groupSubscriptionType={GROUP_SUBSCRIPTION_GIFT}
              />
            </>
          )}
        </>
      )}
    </>
  );
};

export default Gift;
